import { FC } from 'react';

import { Flex, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import useSWR from 'swr';

import Card from '@/components/RCard';
import {
  SimulationBatteryDegradation,
  SimulationResult,
  SimulationResultYearlyFinancialAnalysis,
} from '@/types/simulations';

import StyledInfoCard from './styles';

type InfoCardProps = {
  simulationId?: number;
};

const InfoCard: FC<InfoCardProps> = ({ simulationId }) => {
  const { t } = useTranslation();
  const params = useParams<Record<string, string>>();
  const resultId = simulationId || params.resultId;
  const { data: batteryDegData } = useSWR<SimulationBatteryDegradation>(
    `/simulation/${resultId}/battery_degradation/`,
    {
      revalidateOnFocus: false,
    }
  );
  const { data: simulationData } = useSWR<SimulationResult>(
    `/simulation/${resultId}/`,
    {
      revalidateOnFocus: false,
    }
  );
  const { data: financialData } =
    useSWR<SimulationResultYearlyFinancialAnalysis>(
      `/simulation/${resultId}/yearly_financial_analysis/`,
      {
        revalidateOnFocus: false,
      }
    );

  const replacementYears = financialData?.graphData
    .filter((item) => item.batteryReplacementCount !== 0)
    .map((item) => item.year);

  return (
    <Card style={{ marginTop: '24px' }}>
      <StyledInfoCard vertical gap={24} align="center" justify="center">
        <Flex vertical gap={8} align="center" justify="center">
          <Typography.Text className="title">
            {t('result.energy.infoCard.totalCycleNumber')}
          </Typography.Text>
          <Typography.Text className="number">
            {simulationData?.result.cycleNumber.toFixed(1)}
          </Typography.Text>
        </Flex>
        <Flex vertical gap={8} align="center" justify="center">
          <Typography.Text className="title">
            {t('result.energy.infoCard.sohAtEndOfSim')}
          </Typography.Text>
          <Typography.Text className="number">
            %{' '}
            {(batteryDegData && (batteryDegData.endSoh * 100).toFixed(1)) ||
              '0'}
          </Typography.Text>
        </Flex>
        <Flex vertical gap={8} align="center" justify="center">
          <Typography.Text className="title">
            {replacementYears && replacementYears.length > 1
              ? t('result.energy.infoCard.batteryReplacementYears')
              : t('result.energy.infoCard.batteryReplacementYear')}
          </Typography.Text>
          <Typography.Text className="number">
            {' '}
            {replacementYears && replacementYears.length > 0
              ? replacementYears.join(' & ')
              : '-'}
          </Typography.Text>
        </Flex>
      </StyledInfoCard>
    </Card>
  );
};
export default InfoCard;
